import { CaretDownFilled, FilterOutlined, SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Input,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  Menu,
  Checkbox,
  Dropdown,
} from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { User } from '../../../../models/user'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { getFullUserList } from '../../../completion/completionSlice'
import { getFullDoctorList } from '../../../registration/list/registrationSlice'
import styles from './dentureLedgerPage.module.css'
import { DateRangeFieldName, DateRangeType, DateSelect, getDateRange } from '../../../../compnents/form/DateSelect'
import { FilterColumn } from '../../../../compnents/filterForm/filterForm'

export const Query = (props: {
  loading?: any
  exportLoading?: any
  filterColumn?: any
  filterSelectList?: any
  submitPageList?: (v: any) => void
  onValueChange: (params: any) => void
  exportExcel: () => void
  add: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [doctors, setDoctors] = useState<any>([])

  const [current, setCurrent] = useState<any>()

  const [head, tail] = getDateRange(DateRangeType.Today)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_yichitaizhang') || '{}'
  )

  useEffect(() => {
    if (
      Object.keys(storageParams).length
    ) {
      form.setFieldsValue({
        ...storageParams,
        timeHead: storageParams?.startDate || head,
        timeTail: storageParams?.endDate || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
      })
    } else {
      form.setFieldsValue({
        _dateRange: 0,
        timeHead: head,
        timeTail: tail,
      })
    }
    refresh()
  }, [])

  const refresh = () => {
    props.onValueChange({
      ...storageParams,
      ...form.getFieldsValue(),
      current: current || 1,
    })
  }

  useEffect(() => {
    dispatch(getFullDoctorList())
      .then(unwrapResult)
      .then((ds: any) => setDoctors(ds))
      .catch(() => {
        // do nothing
      })
  }, [])

  return (
    <Form
      className={styles.formStyle}
      form={form}
      onFinish={(values) => {
        const data =
          storageParams || {}
        const dataParams = {
          ...data,
          ...values,
          current: current,
        }
        props.onValueChange({
          ...dataParams,
        })
      }}
    >
      <Row style={{ marginBottom: 10 }} justify='space-between'>
        <Space>
          <DateSelect
            allowClear={false}
            style={{ width: '8.5rem' }}
            labelPrefix=''
            namePrefix='time'
            placeholder='时间范围-时间'
            initialValue={DateRangeType.Today}
            onChange={(e) => {
              if (e != 6) {
                refresh()
              }
            }}
          />
          <Form.Item noStyle name='keyWord'>
            <Input
              autoComplete='off'
              maxLength={20}
              placeholder='患者姓名/助记码/手机号/病历号'
              style={{ width: '15rem' }}
              allowClear
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            />
          </Form.Item>
          <Form.Item noStyle name='variety'>
            <Input
              autoComplete='off'
              maxLength={20}
              placeholder='义齿品种'
              style={{ width: '8rem' }}
              allowClear
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            />
          </Form.Item>
          <Form.Item name='doctorId' noStyle>
            <Select
              allowClear
              placeholder='医生'
              style={{
                width: '8rem',
              }}
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            >
              {doctors.map((d: any) => (
                <Select.Option key={d.id} value={d.id}>
                  {d.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              setCurrent(1)
              refresh()
            }}
          >
            查询
          </Button>
          <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val:any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            type='primary'
            onClick={() => {
              props?.exportExcel && props?.exportExcel()
            }}
          >
            导出
          </Button>
          <Button
            type='primary'
            onClick={() => {
              props?.add && props?.add()
            }}
          >
            新增
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

